import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from '@angular/core';
import {catchError, map, Observable, of} from 'rxjs';
import * as _ from 'lodash';
import {VisitPlanHttpService} from '../../services/visit-plan-http.service';

interface VisitPlanExtendedServiceTimesViewModel {
  previousProjectServiceTime: number;
  nextProjectServiceTime: number;
}

@Component({
  standalone: false,
  selector: 'app-visit-plan-extended-service-times-tooltip',
  templateUrl: './visit-plan-extended-service-times-tooltip.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanExtendedServiceTimesTooltipComponent implements OnInit {

  @Input() visitPlanId: string;
  @Input() accountId: string;

  public extendedServiceTimes$: Observable<VisitPlanExtendedServiceTimesViewModel>;

  constructor(@Inject(VisitPlanHttpService) private visitPlanHttpService: VisitPlanHttpService) {
  }

  ngOnInit() {
    this.extendedServiceTimes$ = this.visitPlanHttpService.getExtendedServiceTimes(this.visitPlanId, this.accountId)
      .pipe(
        map((extendedServiceTimes) => ({
          previousProjectServiceTime: _.sum(_.values(extendedServiceTimes.inScopeBeforeFirstDelivery)),
          nextProjectServiceTime: _.sum(_.values(extendedServiceTimes.after))
        })),
        catchError(() => of({
          previousProjectServiceTime: 0,
          nextProjectServiceTime: 0
        }))
      );
  }
}
